import Vue from "vue";
import { sortBy, entries } from "lodash";

import { HierarchyRepresentation } from "@/lib/apis/replicable/models";
import i18n from "@/lib/i18n";

function filter(value: string | HierarchyRepresentation) {
	if ("string" === typeof value) {
		return value;
	} else {
		return sortBy(entries(value), entry => entry[0])
			.map(codeAndSuggestion => {
				if ("undefined" !== typeof codeAndSuggestion[1].min && codeAndSuggestion[1].min != null) {
					return `${i18n.t(codeAndSuggestion[0])} : >= ${codeAndSuggestion[1].min}`;
				} else if ("undefined" !== typeof codeAndSuggestion[1].max && codeAndSuggestion[1].max != null) {
					return `${i18n.t(codeAndSuggestion[0])} : <= ${codeAndSuggestion[1].max}`;
				} else {
					return `${i18n.t(codeAndSuggestion[0])} : ${codeAndSuggestion[1].value}`;
				}
			})
			.join(", ");
	}
}

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			position: "Position",
			categorie: "Catégorie",
			niveau: "Niveau",
			emploi: "Emploi",
			coefficient: "Coefficient",
			echelon: "Echelon",
			degres: "Degrés",
			palier: "Palier",
			positionnement: "Positionnement",
			groupe: "Groupe",
			indice: "Indice",
			classe: "Classe"
		});

		Vue.filter("suggestion", filter);
	}
};

export { filter };
